import type { ContentfulMediaIcon, IconType } from "types/cms"

import { addGTMEvent } from "utils/gtm"
import type { DataLayerEvent } from "utils/gtm/types"
import type { SegmentTrackEvent } from "@beautypie/segment"

export type CMSPageProps = {
  trackingModule: Omit<CMSPageModule, "moduleClickUrl">
}

export type CMSPageEvents = {
  click: string
  view: string
}

export type CMSPageModule = {
  modulePosition: number
  moduleId: string
  moduleContent: string
  moduleContentDetails?: string
  moduleContentUrl?: string
  pageId?: string
  locationType?: string
  track?: (event: SegmentTrackEvent) => void
}

export const parseIconData = (iconInput: ContentfulMediaIcon): IconType => {
  const { icon } = iconInput
  return {
    id: iconInput.id,
    src: icon.fields.file.url,
    label: iconInput.label,
  }
}

export const parseIconsData = (
  icons: ContentfulMediaIcon[]
): IconType[] | null => {
  return (
    icons?.map((icon) => {
      return parseIconData(icon)
    }) ?? null
  )
}

export const cmsPageClick = (module: CMSPageModule): void => {
  const {
    modulePosition,
    moduleContent,
    moduleContentDetails,
    moduleContentUrl,
    moduleId,
    pageId,
    locationType,
    track,
  } = module

  const optionalProps = {
    ...(moduleContentDetails && {
      ...{ module_content_details: moduleContentDetails },
    }),
    ...(moduleContentUrl && {
      ...{ module_content_url: moduleContentUrl },
    }),
  }

  const trackingModule = {
    module_position: modulePosition,
    module_content: moduleContent,
    module_id: moduleId,
    location_type: locationType,
    ...optionalProps,
  }

  const eventName = `${pageId}-click` as unknown as DataLayerEvent

  addGTMEvent({ name: eventName, data: trackingModule })

  if (track) {
    track({
      event: "Page Element Clicked",
      properties: trackingModule,
    })
  }
}
